var _SIZING_ICONS;

import React from 'react';
import { bgImageSizings, positions, sizes } from "../../../../enums";
import Label from "../../../core/label";
import IconMenu from "../../../core/icon-menu";

function MediaSettingsSizeMenu(_ref) {
  var onChange = _ref.onChange,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? bgImageSizings.COVER : _ref$value,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Image display sizing' : _ref$label;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Label, {
    text: label
  }), /*#__PURE__*/React.createElement(IconMenu, {
    id: "size",
    items: SIZING_OPTIONS,
    activeValue: value,
    size: sizes.X5,
    onItemClick: onChange
  }));
}
/** ########################################################################################
    PRIVATE HELPERS
    ######################################################################################## */


var SIZING_ICONS = (_SIZING_ICONS = {}, _SIZING_ICONS[bgImageSizings.AUTO] = /*#__PURE__*/React.createElement("svg", {
  id: "bg-size-auto",
  width: "50",
  height: "50",
  viewBox: "0 0 49 49",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  id: "Components",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon-block-element",
  fill: "#D3D8DB",
  d: "M0 0h49v49H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon-image-element",
  fill: "#B1B8BE",
  d: "M13 32h24.27l-5.114-11.6-4.28 5.17L19.152 18z"
}))), _SIZING_ICONS[bgImageSizings.CONTAIN] = /*#__PURE__*/React.createElement("svg", {
  id: "bg-size-contain",
  width: "50",
  height: "50",
  viewBox: "0 0 49 49",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  id: "Components",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon-block-element",
  fill: "#D3D8DB",
  d: "M0 0h49v49H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon-image-element",
  fill: "#B1B8BE",
  d: "M0 37.266h49l-10.325-23.42-8.64 10.44L12.42 9z"
}))), _SIZING_ICONS[bgImageSizings.COVER] = /*#__PURE__*/React.createElement("svg", {
  id: "bg-size-cover",
  width: "50",
  height: "50",
  viewBox: "0 0 49 49",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  id: "Components",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon-block-element",
  fill: "#D3D8DB",
  d: "M0 0h49v49H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon-image-element",
  d: "M0 18.206L4.783 9l29.48 21.63 14.458-14.773.28.534V49H0V18.206z",
  fill: "#B1B8BE"
}))), _SIZING_ICONS);
var SIZING_OPTIONS = [{
  tooltip: 'Cover automatically fills space while maintaining aspect ratio. The focus will be on the center of the image.',
  tooltipPosition: positions.TOP_RIGHT,
  tooltipIsCompact: false,
  value: bgImageSizings.COVER,
  icon: SIZING_ICONS[bgImageSizings.COVER]
}, {
  tooltip: 'Contain scales image to maintain its aspect ratio while fitting within the given space. It is ideal for use of irregular design assets and product images.',
  tooltipPosition: positions.TOP_RIGHT,
  tooltipIsCompact: false,
  value: bgImageSizings.CONTAIN,
  icon: SIZING_ICONS[bgImageSizings.CONTAIN]
}, {
  tooltip: 'Native, use an actual image size.',
  value: bgImageSizings.AUTO,
  icon: SIZING_ICONS[bgImageSizings.AUTO]
}];
export default MediaSettingsSizeMenu;
//# sourceMappingURL=media-settings-size-menu.js.map